import React from 'react';

import { ReactComponent as ApprovalWorkflowSVG } from '../../assets/icons/approval-workflow.svg';
import { ReactComponent as CadConversionSVG } from '../../assets/icons/cad-conversion.svg';
import { ReactComponent as ArrowRightSVG } from '../../assets/icons/green-arrow-right.svg';
import { ReactComponent as PlayCircleSVG } from '../../assets/icons/play-circle.svg';
import { ReactComponent as PrintingSVG } from '../../assets/icons/printing-service.svg';
import { ReactComponent as PaymentSVG } from '../../assets/icons/secure-payment.svg';
import { Button, Typography } from '../../designComponents';
import {
  LearnMoreButtonStyled,
  StrategicCardStyled,
  StrategicChoiceStyled,
} from './landing-styles';

interface StrategicCardProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  description: string;
  title: string;
}

const StrategicCard: React.FC<StrategicCardProps> = ({
  icon: Icon,
  description,
  title,
}) => {
  return (
    <StrategicCardStyled>
      <Icon className="icon" />
      <Typography className="title">{title}</Typography>
      <Typography className="desc">{description}</Typography>
      <LearnMoreButtonStyled>
        <Typography className="learn-more">Learn More</Typography>
        <ArrowRightSVG />
      </LearnMoreButtonStyled>
    </StrategicCardStyled>
  );
};

const StrategicChoice = () => {
  return (
    <StrategicChoiceStyled>
      <div className="info-container">
        <Typography className="info-header" strong>
          We stand as your strategic choice
        </Typography>
        <Typography className="info-desc">
          Offering unparalleled expertise and support for all your escape. Our
          mission is to bring transparency to finance by providing upfront and
          clear information.
        </Typography>
        <div className="btn-wrapper">
          <Button>
            <PlayCircleSVG height="24px" width="24px" /> Watch Demo Guide
          </Button>
        </div>
      </div>

      <div className="card-grid-container">
        <StrategicCard
          description="Transform your building drawings into professional CAD files and PDF escape plans with our expert CAD conversion services."
          title="CAD Conversion"
          icon={CadConversionSVG}
        />
        <StrategicCard
          description="Collaborate seamlessly with our team through our streamlined approval workflow. Review and approve escape plans with ease."
          title="Approval Workflow"
          icon={ApprovalWorkflowSVG}
        />
        <StrategicCard
          description="Choose from a variety of materials and sizes for your escape plan posters."
          title="Printing Services"
          icon={PrintingSVG}
        />
        <StrategicCard
          description="Pay conveniently and securely via Stripe for your orders with transparent pricing based on package and quantity."
          title="Secure Payments"
          icon={PaymentSVG}
        />
      </div>
    </StrategicChoiceStyled>
  );
};

export default StrategicChoice;
